module.exports = __webpack_public_path__ + "static/media/89.a2da9256.jpg";